import React from "react"
import { Box, Text, Button } from "@chakra-ui/react"
import { SectionProps, withSection } from "@app/hoc/Section"
import ProductSizeFitDrawerNonPDP from "@app/components/Product/productSizeFitDrawerNonPDP"

export type FitAssistantProps = GatsbyTypes.SanitySectionFitAssistant & SectionProps

const FitAssistant = ({ title, buttonText }: FitAssistantProps) => {
  const [drawerType, setDrawerType] = React.useState("")

  const handleOptions = () => {
    console.log("")
  }

  return (
    <>
      <Box as="section" textAlign={"center"} marginTop="-25px" minW={"unset"} px={[2, "0 !important"]}>
        <Box>
          <Text>{title}</Text>
          <Button mt="10px" variant="blue" onClick={() => setDrawerType("fit-assistant")}>
            {buttonText}
          </Button>
        </Box>
      </Box>

      <ProductSizeFitDrawerNonPDP
        isOpen={!!drawerType}
        drawerType={drawerType}
        handleDrawerType={setDrawerType}
        onClose={() => setDrawerType("")}
      />
    </>
  )
}

export default React.memo(withSection(FitAssistant))
